<template>
  <div class="con-vs-pagination vs-pagination-primary">
    <nav class="vs-pagination--nav">
      <button @click="changePage(value - 1)" class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev " :class="{'disabled': value == 1}">
        <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
      </button>
      <ul class="vs-pagination--ul">

        <li @click="changePage(page)" class="item-pagination vs-pagination--li " v-for="page in pagesNumber" :class="{'is-current': page === value , 'disabled' : !isNumber(page)}" >
          <span> {{ page }} </span><div class="effect"></div>
        </li>

      </ul>
      <button @click="changePage(value + 1)" class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :class="{'disabled': value >= lastPage}">
        <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
      </button>
    </nav>
  </div>
</template>

<script>

  class UrlWindow{
    static make(current_page, last_page, onEachSide = 3){
      return (new UrlWindow(current_page, last_page)).getWindowUrl(onEachSide);
    }
    static getUrlRange(start,end,step = 1){
      return new Array(Math.floor((end - start) / step) + 1)
        .fill(0)
        .map((v, i) => start + i * step);
    }

    constructor(current_page, last_page){
      this.paginator = {
        current_page,
        last_page,
      };
    }

    getWindowUrl(onEachSide = 3){
      if(this.lastPage() < (onEachSide * 2)+6){
        return this.getSmallSlider();
      }
      return this.getUrlSlider(onEachSide);
    }
    getSmallSlider(){
      return {
        'first': UrlWindow.getUrlRange(1, this.lastPage()),
        'slider':null,
        'last':null
      }
    }
    getUrlSlider(onEachSide){
      let _window = onEachSide * 2;
      if(!this.hasPages()){
        return {
          'first': null,
          'slider':null,
          'last':null
        }
      }

      if(this.currentPage() <= _window){
        return this.getSliderTooCloseToBeginning(_window);
      }else if(this.currentPage() > (this.lastPage() - _window)){
        return this.getSliderTooCloseToEnding(_window);
      }

      return this.getFullSlider(onEachSide);

    }
    getSliderTooCloseToBeginning(_window){
      return {
        'first': UrlWindow.getUrlRange(1, _window + 2),
        'slider':null,
        'last':this.getFinish()
      }
    }
    getSliderTooCloseToEnding(_window){
      let last = UrlWindow.getUrlRange(this.lastPage() - (_window +2),this.lastPage());
      return {
        'first': this.getStart(),
        'slider':null,
        'last': last
      }
    }
    getFullSlider(onEachSide){
      return {
        'first': this.getStart(),
        'slider': this.getAdjacentUrlRange(onEachSide),
        'last':this.getFinish()
      }
    }
    getAdjacentUrlRange(onEachSide){
      return UrlWindow.getUrlRange(this.currentPage() - onEachSide, this.currentPage() + onEachSide);
    }
    getStart(){
      return UrlWindow.getUrlRange(1,2);
    }
    getFinish(){
      return UrlWindow.getUrlRange(this.lastPage()-1,this.lastPage());
    }
    hasPages(){
      return this.paginator.last_page > 1;
    }
    currentPage(){
      return this.paginator.current_page;
    }
    lastPage(){
      return this.paginator.last_page;
    }
  }

  export default{
    props: {
      value : Number,
      onEachSide: {
        type: Number,
        default(){ return 3}
      },
      lastPage : {
        type : Number,
        default() {
          return 1;
        }
      }
    },
    computed: {
      pagesNumber() {
        let _window = (new UrlWindow(this.value, this.lastPage)).getWindowUrl(this.onEachSide);

        let data = [
          _window.first,
          _window.slider instanceof Array ? '...' : null,
          _window.slider,
          _window.last instanceof Array ? '...' : null,
          _window.last
        ];

        let elements = data.filter((item) => item !== null);

        let pagesArray = [];

        for(let element of elements){
          if(element instanceof Array){
            for(let i of element){
              pagesArray.push(i);
            }
          }else{
            pagesArray.push(element);
          }
        }
        return pagesArray;

      }
    },
    methods : {
      changePage(page) {
        this.$emit('input',page);
      },
      isNumber(page){
        return "number" === typeof page;
      }
    }
  }
</script>
